import React from "react";
import "./Loading.css"
import loading from "../../../icons/Logo_loading.png";
import { useRol } from "../../../Context";

function Loading() {
    const { isLoadingAuth } = useRol();

    return (
        <>
            <div className="backgroound column-direction-error">
                <img src={loading} alt="loading" className="imagen" />
                <div className="container-loading">
                    <div className="loadingio-spinner-spin-2b0pc6qp82s"><div className="ldio-bzxxzaxttql">
                        <div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div>
                    </div></div>
                    <div className="cargando-loading">
                        {isLoadingAuth ? "Verificando sesión..." : "Cargando..."}
                    </div>
                </div>
            </div>
        </>
    )
}

export { Loading }